module.exports = __webpack_public_path__ + "img/idbadge.d582e1ad.svg";